import React from "react";
import { Link } from "react-router-dom";
const styleOptions = [
  "ghibli",
  "anime",
  "claymation",
  "puppet",
  "pixel",
  "pixar",
  "disney",
  "lego",
];

const StyleSelector: React.FC = () => {
  const imagePath = (key: string) => `/previews/thai_female_${key}.jpeg`;

  return (
    <div className="mb-8">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
        {styleOptions.map((key) => (
          <Link
            key={key}
            to={`/upload/${encodeURIComponent(key)}`}
            className={`relative rounded-xl border-2 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 overflow-hidden
            `}
            aria-pressed={key === "ghibli"}
            style={{ aspectRatio: "105 / 150" }}
          >
            <img
              src={imagePath(key)}
              alt={key + " preview"}
              className="absolute inset-0 object-cover w-full h-full transition-transform duration-200 ease-in-out group-hover:scale-105"
              onError={(e) => {
                (e.target as HTMLImageElement).src =
                  "https://placehold.co/105x150?text=Preview";
              }}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default StyleSelector;
